import React from "react";
import DeviceDataList from "./DeviceDataList";
import DeviceShowItem from "./DeviceShowItem";
import DeviceEditForm from "./DeviceEditForm";

///////////////////// LIST ALL DEVICES /////////////////////
export const DeviceList = props => <DeviceDataList {...props} />;

///////////////////// SHOW DEVICE /////////////////////
export const DeviceShow = props => <DeviceShowItem {...props} />;

///////////////////// EDIT DEVICE /////////////////////
export const DeviceEdit = props => <DeviceEditForm {...props} />;



// WEBPACK FOOTER //
// ./src/containers/CRM/Devices/index.js